<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-menu-button></ion-menu-button>
                </ion-buttons>
                <ion-title>Mei Biodynamic Extermination</ion-title>
                <div class="flex ion-padding-horizontal" slot="end">
                    <ion-img
                        :src="logoImg"
                        style="
                            background-color: white;
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            object-fit: contain;
                            position: relative;
                            overflow: hidden;
                        "
                        alt="The Wisconsin State Capitol building in Madison, WI at night"></ion-img>
                    <ion-text
                        :color="isOnline ? 'success' : 'danger'"
                        style="position: absolute; top: -6px; right: 6px; font-weight: bold; font-size: 28px">
                        •
                    </ion-text>
                </div>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true" class="home-content">
            <map-box
                ref="mapBox"
                height="90vh"
                border-radius="16px"
                class="ion-padding"
                style="margin-top: 55px"
                :max-zoom="18"
                :markers-data="costumersMarkers"
                :disable-interactions="false"></map-box>
        </ion-content>
        <div
            style="
                height: 22vh;
                display: grid;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                gap: 8px;
                padding: 24px;
            "
            class="ion-padding">
            <home-button target-route="costumers" :icon="peopleOutline" label="Clienti"></home-button>
            <home-button target-route="planning" :icon="listCircleOutline" label="Pianificazione"></home-button>
            <home-button target-route="calendar" :icon="calendarOutline" label="Calendario"></home-button>
            <div></div>
            <home-button target-route="contractExpirations" :icon="alertCircleOutline" label="Scadenze"></home-button>
        </div>
    </ion-page>
</template>

<script setup lang="ts">
import {
    IonPage,
    IonHeader,
    IonIcon,
    IonImg,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonMenuButton,
    IonText,
    isPlatform,
} from "@ionic/vue";
import { computed, ref, onMounted } from "vue";
import MapBox from "@/components/MapBox.vue";
import { useCostumersStore } from "@/stores/costumers";
import { useNetworkStore } from "@/stores/network";
import { useInspectionsStore } from "@/stores/inspections";
import { useInterventionFrequencyStore } from "@/stores/interventionFrequencies";
import { useContractsStore } from "@/stores/contracts";
import { useTrapsStore } from "@/stores/traps";
import { getMarkerIconUrl } from "@/types/intervention_frequency";
import { IExtendedMarkerOptions } from "@/types/maps";
import { calendarOutline, listCircleOutline, peopleOutline, alertCircleOutline } from "ionicons/icons";
import HomeButton from "@/components/elements/HomeButton.vue";
import logoImg from "@/assets/images/logo.svg";

const costumersStore = useCostumersStore();
const networkStore = useNetworkStore();
const inspectionsStore = useInspectionsStore();
const interventionFrequencyStore = useInterventionFrequencyStore();
const contractsStore = useContractsStore();
const trapsStore = useTrapsStore();

const mapBox = ref<InstanceType<typeof MapBox> | null>(null);
const isOnline = computed(() => networkStore.isOnline);

const costumersMarkers = computed(
    () =>
        costumersStore.getCostumers
            .filter((item) => item.latitude && item.longitude && item.expiration_state)
            .map(
                (item) =>
                    ({
                        position: {
                            lat: Number(item.latitude!),
                            lng: Number(item.longitude!),
                        },
                        icon: getMarkerIconUrl(item.expiration_state!),
                        title: item.business_name,
                        clickable: true,
                        infoWindowHTML: `<p>Ultima ispezione: ${item.last_inspection_delta} giorni fa</p>`,
                        costumerId: item.id,
                    } as IExtendedMarkerOptions & { costumerId: number }),
            ) as IExtendedMarkerOptions[],
);

onMounted(() => {
    interventionFrequencyStore.loadInspectionFrequencies();
    costumersStore.loadCostumers();
    costumersStore.loadArchivedCostumers();
    inspectionsStore.loadInspections();
    trapsStore.loadTraps();
    contractsStore.loadContracts();
});
</script>

<style scoped>
.home-content {
    --padding-top: 0;
    --padding-bottom: 0;
    --padding-start: 0;
    --padding-end: 0;
}
</style>
